import * as React from 'react';
import { CssVarsProvider } from '@mui/joy/styles';
import CssBaseline from '@mui/joy/CssBaseline';
import Box from '@mui/joy/Box';
import Typography from '@mui/joy/Typography';
import Button from '@mui/joy/Button';
import Stack from '@mui/joy/Stack';

import CreateRoundedIcon from '@mui/icons-material/CreateRounded';
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';

import Layout from 'src/components/email/Layout';
import Navigation from 'src/components/email/Navigation';
import Mails from 'src/components/email/Mails';
import EmailContent from 'src/components/email/EmailContent';
import WriteEmail from 'src/components/email/WriteEmail';
import Header from 'src/components/email/Header';
import { useSelector } from 'src/reducers';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { EmailLogsRequest } from 'src/actions/emailLogActions';
import { Bars } from 'react-loader-spinner';
import Pagination from 'src/components/email/Pagination';

export default function EmailList() {

  const dispatch = useDispatch();
  const [filters, setFilters] = React.useState<any>({});
  const [pageNo, setPageNo] = React.useState<number>(1);
  const [limit, setLimit] = React.useState<number>(50);
  const [drawerOpen, setDrawerOpen] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [emailIndex, setEmailIndex] = React.useState<number>(0);
  const { loading, metadata, data } = useSelector(state => state.emailLog);

  useEffect(() => {
    dispatch(EmailLogsRequest(filters, pageNo, limit))
  }, [pageNo, limit, filters]);

  const sentEmailInd = (index: number) => {
    setEmailIndex(index)
  }

  return (
    <CssVarsProvider disableTransitionOnChange>
      <CssBaseline />
      {drawerOpen && (
        <Layout.SideDrawer onClose={() => setDrawerOpen(false)}>
          <Navigation />
        </Layout.SideDrawer>
      )}

      <Stack
        id="tab-bar"
        direction="row"
        spacing={1}
        sx={{
          justifyContent: 'space-around',
          display: { xs: 'flex', sm: 'none' },
          zIndex: '999',
          bottom: 0,
          position: 'fixed',
          width: '100dvw',
          py: 2,
          backgroundColor: 'background.body',
          borderTop: '1px solid',
          borderColor: 'divider',
        }}
      >
        <Button
          variant="plain"
          // color="neutral"
          aria-pressed="true"
          component="a"
          // href="/joy-ui/getting-started/templates/email/"
          size="sm"
          startDecorator={<EmailRoundedIcon />}
          sx={{bgcolor:"rgb(237, 171, 42)",
            '&:hover': {
              backgroundColor: 'rgb(237, 171, 42)', // Change the color on hover
            }, flexDirection: 'column', '--Button-gap': 0 }}
        >
          Email
        </Button>
      </Stack>
      <Layout.Root
        sx={[
          drawerOpen && {
            height: '100vh',
            overflow: 'hidden',
          },
        ]}
      >
        <Layout.Header>
          <Header setFilters={setFilters} filters={filters} />
        </Layout.Header>
        <Layout.SideNav>
          <Navigation />
        </Layout.SideNav>
        <Layout.SidePane>
          <Box
            sx={{
              p: 2,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <Box sx={{ alignItems: 'center', gap: 1 }}>
              <Typography level="title-lg" textColor="text.secondary" component="h1">
                My inbox
              </Typography>
              <Typography level="title-sm" textColor="text.tertiary">
                {!loading && metadata.total} emails
              </Typography>
            </Box>
            <Button
              size="sm"
              startDecorator={<CreateRoundedIcon />}
              onClick={() => setOpen(true)}
              sx={{ ml: 'auto',bgcolor:"rgb(237, 171, 42)",
                '&:hover': {
                  backgroundColor: 'rgb(237, 171, 42)', // Change the color on hover
                },

               }}
            >
              Compose email
            </Button>
            <WriteEmail open={open} onClose={() => setOpen(false)} />
          </Box>
          {loading ? <Bars height="50" width="50" color="#EDAB2A" ariaLabel="loading-indicator" /> :
            data.length ? <Box><Mails data={data} emailIndex={emailIndex} sentEmailInd={sentEmailInd} />
              <Pagination limit={metadata.limit} pageNo={metadata.pageNo} total={metadata.total} setPageNo={setPageNo} />
            </Box> : ""
          }
        </Layout.SidePane>
        <Layout.Main>
          {loading ? <Bars height="50" width="50" color="#EDAB2A" ariaLabel="loading-indicator" /> : data.length ? <EmailContent setFilters={setFilters} emailData={data[emailIndex]} /> : ""}
        </Layout.Main>
      </Layout.Root>
    </CssVarsProvider>
  );
}
